import { Link } from "react-router-dom";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryEntry from "@/pages/home/components/CategoryEntry";
import SectionHeader from "@/components/feature/SectionHeader";
import MovieGrid from "@/components/feature/MovieGrid";
import { getLatestMovies, getPopularMovies } from "@/lib/movieUtils";

export default function Home() {
  const latest = getLatestMovies(10);
  const popular = getPopularMovies(10);

  return (
    <>
      <HeroCarousel />

      <div className="w-full max-w-[1440px] mx-auto px-4 md:px-8 -mt-6 md:-mt-10 relative z-20 space-y-12 md:space-y-16 pb-16 md:pb-20">
        <CategoryEntry />

        <section id="latest" className="scroll-mt-24">
          <SectionHeader
            title="最新影视推荐"
            subtitle="按最近更新时间为你精选的影视内容"
            icon="ri-time-line"
            moreTo="/category/movie"
            moreLabel="查看全部"
          />
          <MovieGrid movies={latest} emptyText="暂无推荐内容，敬请期待" />
        </section>

        <section id="popular" className="scroll-mt-24">
          <SectionHeader
            title="热门影视精选"
            subtitle="播放量领先的高人气影视作品"
            icon="ri-fire-line"
            moreTo="/category/series"
            moreLabel="查看全部"
          />
          <MovieGrid movies={popular} showViews emptyText="暂无推荐内容，敬请期待" />
        </section>

        <section className="rounded-lg overflow-hidden border border-background-200/70 bg-gradient-to-r from-primary-950/80 to-background-100">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 p-6 md:p-10 items-center">
            <div>
              <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-500/15 text-primary-300 text-xs font-semibold mb-4">
                <i className="ri-leaf-fill" />
                关于青青草视频
              </span>
              <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 leading-snug">
                青青草视频
                <span className="block mt-2 text-lg md:text-xl font-semibold text-foreground-700">
                  高清影视资源浏览与最新影视推荐平台
                </span>
              </h1>
              <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
                青青草视频汇聚电影、电视剧、综艺等多元影视内容，通过清晰的分类、实时的筛选与便捷的搜索，帮助影视爱好者快速发现感兴趣的作品。我们专注内容推荐与信息服务，为你打造流畅舒适的浏览体验。
              </p>
              <div className="mt-6 flex flex-wrap gap-3">
                <Link
                  to="/about"
                  className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  了解更多
                  <i className="ri-arrow-right-line" />
                </Link>
                <Link
                  to="/contact"
                  className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-background-200/70 text-foreground-900 text-sm font-semibold hover:bg-background-300/70 transition-colors whitespace-nowrap cursor-pointer"
                >
                  联系我们
                </Link>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              {[
                { value: "24+", label: "精选影视作品", icon: "ri-video-line" },
                { value: "3", label: "核心影视分类", icon: "ri-layout-grid-line" },
                { value: "8", label: "覆盖地区", icon: "ri-earth-line" },
                { value: "4", label: "多维筛选方式", icon: "ri-filter-3-line" },
              ].map((stat) => (
                <div
                  key={stat.label}
                  className="rounded-lg bg-background-100 border border-background-200/70 p-5"
                >
                  <span className="w-10 h-10 rounded-md bg-accent-500/15 flex items-center justify-center mb-3">
                    <i className={`${stat.icon} text-lg text-accent-400`} />
                  </span>
                  <p className="font-heading text-2xl font-bold text-foreground-950">
                    {stat.value}
                  </p>
                  <p className="text-xs text-foreground-600 mt-1">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}